export default __webpack_public_path__ + "static/media/img-doc-search.e6271fe3.svg";